import dateUtils from '@utils/DateUtils'
import sizeUtils from '@utils/sizeUtils'
import utils from '@utils/genUUID'
import BaseModel from '@/models/base-model'
import config from '@/config'
function getRandomColor () {
  let letters = '0123456789ABCDEF'
  let color = '#'
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}
export default class Image extends BaseModel {
  constructor (obj) {
    super(obj)
    this._isRaster = true
    this._ssrTileUrl = `${config.ssr_tile_url}/tile/eof/${obj.owner_id}/${obj.workspace_id}/${obj.id}/{z}/{x}/{y}.png`.replace(
      /-/g,
      ''
    )
    this.bbox = obj.bbox
    this.src = obj.src
    this._isResult = obj.is_result
    this._cutLine = undefined
    this._isReport = obj.isReport ? obj.isReport : false
    this._isNvdi = obj.image_type ? this.checkNVDI(obj.image_type) : false
    this._tileUrl = obj.tileUrl ? obj.tileUrl : obj.tile_url
    this._downloadUrl = obj.download_url
    this._isTraining = obj.isTraining ? obj.isTraining : false
    this._task_id = obj.task_id
    this._colorPalette = []
    this._noData = obj.nodata ? obj.nodata : 0
    this._bounds = obj.bounds ? obj.bounds : undefined
    this._type = obj.image_type ? obj.image_type : 'None'
    this._created = obj.created_at
      ? dateUtils.convertUTCToLocalDateV2(obj.created_at)
      : undefined
    this._size = this.transf(obj.size_mb)
    this._visible = false
    this._owner = obj.owner_id
    this._thumbnail = obj.thumbnail
    this._imageType = obj.image_type
    this._terrain = obj.terrain
    this._workspaceId = obj.workspace_id
    this._createdBy = obj.owner ? obj.owner : undefined
    this._acquired = obj.acquired ? obj.acquired : undefined
    this._categories = obj.categories ? obj.categories : []
    this._meta = obj.meta
      ? {
        refImageBands: obj.meta.ref_image_bands
          ? this.transFormBand(obj.meta.ref_image_bands)
          : [],
        AREA_OR_POINT: obj.meta.AREA_OR_POINT,
        bands: this.transFormBand(obj.meta.BANDS),
        OVR_RESAMPLING_ALG: obj.meta.OVR_RESAMPLING_ALG,
        PROJECTION: obj.meta.PROJECTION,
        X_SIZE: obj.meta.X_SIZE,
        Y_SIZE: obj.meta.Y_SIZE,
        MAX_ZOOM: obj.meta.MAX_ZOOM,
        MIN_ZOOM: obj.meta.MIN_ZOOM,
        PIXEL_SIZE_X: obj.meta.PIXEL_SIZE_X,
        PIXEL_SIZE_Y: obj.meta.PIXEL_SIZE_Y,
        PIXEL_SIZE_X_METER: obj.meta.PIXEL_SIZE_X_METER,
        PIXEL_SIZE_Y_METER: obj.meta.PIXEL_SIZE_Y_METER,
        ORIGIN_X: obj.meta.ORIGIN_X,
        ORIGIN_Y: obj.meta.ORIGIN_Y,
        bbox: obj.meta.bbox,
        rawReference: obj.meta.raw_image
          ? obj.meta.raw_image.name
          : undefined,
        linkRaw: obj.meta.raw_image
          ? obj.meta.raw_image.download_url
          : undefined,
        cropScout: obj.meta.crop_scout ? obj.meta.crop_scout : undefined,
        labels: obj.meta.labels ? obj.meta.labels : undefined,
        histogram: obj.meta.histogram_values
          ? obj.meta.histogram_values
          : undefined,
        imageRef: obj.meta.ref_image_id ? obj.meta.ref_image_id : undefined,
        modelRef: obj.meta.ref_image_id ? obj.meta.ref_image_id : undefined,
        crs: obj.meta.crs ? obj.meta.crs : undefined
      }
      : undefined
    this._symbology = obj.symbology
      ? this.transformValue(obj.symbology)
      : undefined
    this._children = obj.children || []
    this._isExpand = obj.isExpand ? obj.isExpand : false
    this._bands =
      obj.symbology && obj.symbology.bands ? obj.symbology.bands : [0, 0, 0]
    this._mode =
      obj.symbology && obj.symbology.mode ? obj.symbology.mode : 'multiband'
    this._listValue =
      obj.symbology && obj.symbology.listValue ? obj.symbology.listValue : []
    this._formulas =
      obj.symbology && obj.symbology.formulas ? obj.symbology.formulas : {}
    this._url = obj.thumbnail
    this._interpolation =
      obj.symbology && obj.symbology.interpolation
        ? obj.symbology.interpolation
        : ''
    this._contrastEnhancement =
      obj.symbology && obj.symbology.contrastEnhancement
        ? obj.symbology.contrastEnhancement
        : 'no'
    this._calculateStretch =
      obj.symbology && obj.symbology.stretchValue
        ? obj.symbology.stretchValue
        : ''
    this._cutLine = obj.cutLine ? obj.cutLine : undefined
    this._isOwnerSymbology = obj.is_owner_symbology
  }

  transformValue (symbology) {
    if (symbology.listValue) {
      symbology.listValue.forEach(val => {
        if (val.value !== '' && val.value !== undefined && val.value !== null) {
          val['minValue'] = val['value']
          delete val['value']
        }
      })
    }
    return symbology
  }

  transf (size) {
    return sizeUtils.transfSize(size)
  }
  transFormBand (bands) {
    let BANDS = bands.map(val => {
      return {
        ID: val.ID,
        NAME: val.NAME || 'Band ' + (val.ID + 1),
        MAX: val.MAX,
        MIN: val.MIN,
        DATA_TYPE: val.DATA_TYPE,
        DESCRIPTION: val.DESCRIPTION,
        NO_DATA_VALUE: val.NO_DATA_VALUE,
        STATISTICS_MAXIMUM: val.STATISTICS_MAXIMUM,
        STATISTICS_MEAN: val.STATISTICS_MEAN,
        STATISTICS_MINIMUM: val.STATISTICS_MINIMUM,
        STATISTICS_STDDEV: val.STATISTICS_STDDEV
      }
    })
    // BANDS.splice(3, 1)
    return BANDS
  }

  checkNVDI (code) {
    if (code === 'sentinel2' || code === 'planet') {
      return true
    } else {
      return false
    }
  }

  checkHazeRemoval (code) {
    if (code !== 'sentinel1') {
      return true
    } else {
      return false
    }
  }
  checkDeadTree () {
    return this._type === 'planet'
  }
  get isRaster () {
    return this._isRaster
  }
  get terrain () {
    return this._terrain
  }
  get isResult () {
    return this._isResult
  }
  get isReport () {
    return this._isReport
  }
  get isExpand () {
    return this._isExpand
  }
  get downloadUrl () {
    return this._downloadUrl
  }
  get cutLine () {
    return this._cutLine
  }
  set cutLine (newValue) {
    this._cutLine = newValue
  }
  get ownerId () {
    return this._owner
  }
  get symbology () {
    return this._symbology
  }
  set symbology (newValue) {
    this._symbology = newValue
  }
  get categories () {
    return this._categories
  }
  get isTraining () {
    return this._isTraining
  }
  get noData () {
    return this._noData
  }
  get acquired () {
    return this._acquired
  }

  get createdBy () {
    return this._createdBy
  }
  get workspaceId () {
    return this._workspaceId
  }
  get isNvdi () {
    return this._isNvdi
  }
  get visible () {
    return this._visible
  }
  set visible (newValue) {
    this._visible = newValue
  }
  get allowHazeRemoval () {
    return this.checkHazeRemoval(this._type)
  }

  get allowDeadTree () {
    return this.checkDeadTree(this._type)
  }

  get allowView () {
    return !(!this._tileUrl || this._imageType === 'raw')
  }

  get bands () {
    return this._bands
  }

  get tileUrl () {
    return this._tileUrl
  }
  get ssrTileUrl () {
    return this._ssrTileUrl
  }
  set tileUrl (newValue) {
    this._tileUrl = newValue
  }

  get type () {
    return this._type
  }

  get createdAt () {
    return this._created
  }

  get size () {
    return this._size
  }

  get thumbnail () {
    if (!this._bands) {
      return [this._url + '&mode=' + this._mode]
    }
    this._listValue.forEach(val => {
      if (val.value) {
        val.minValue = val.value
      }
    })
    let tile = this._url + '&mode=' + this._mode
    let minmax = this._calculateStretch ? this._calculateStretch : ''
    let contrastEnhancement = this._contrastEnhancement
    let gray
    let red
    let green
    let blue
    let colorMap = ''
    if (this._mode === 'multiband') {
      red =
        this._formulas && this._formulas.bandRed
          ? window.btoa(this._formulas.bandRed)
          : window.btoa('b' + (this._bands[0] + 1))
      green =
        this._formulas && this._formulas.bandGreen
          ? window.btoa(this._formulas.bandGreen)
          : window.btoa('b' + (this._bands[1] + 1))
      blue =
        this._formulas && this._formulas.bandBlue
          ? window.btoa(this._formulas.bandBlue)
          : window.btoa('b' + (this._bands[2] + 1))
      tile = [
        tile +
        '&' +
        `red=${red}&green=${green}&blue=${blue}` +
        '&nodata=' +
        this._noData +
        '&method=' +
        contrastEnhancement +
        '&minmax=' +
        minmax
      ]
    }
    if (
      this._mode === 'gray' ||
      this._mode === 'pseudocolor' ||
      this._mode === 'unique'
    ) {
      gray =
        this._formulas && this._formulas.bandGray
          ? window.btoa(this._formulas.bandGray)
          : window.btoa('b' + (this._bands[0] + 1))
    }
    if (this._mode === 'gray') {
      tile = [
        tile +
        '&' +
        `gray=${gray}` +
        '&nodata=' +
        this._noData +
        '&method=' +
        contrastEnhancement +
        '&minmax=' +
        minmax
      ]
    }
    if (this._mode === 'pseudocolor' || this._mode === 'unique') {
      this._listValue.forEach((val, ind) => {
        val.color = val.color || getRandomColor()
        if (ind === this._listValue.length - 1) {
          colorMap = colorMap + val.minValue + ',' + val.color.replace('#', '')
          return
        }
        colorMap =
          colorMap + val.minValue + ',' + val.color.replace('#', '') + ';'
      })
      if (this._mode === 'pseudocolor') {
        return [
          tile +
          '&' +
          `gray=${gray}` +
          `&color_map=${colorMap}` +
          '&nodata=' +
          this._noData +
          '&method=' +
          contrastEnhancement +
          '&minmax=' +
          minmax +
          '&interpolation=' +
          this._interpolation
        ]
      } else {
        tile = [
          tile +
          '&' +
          `gray=${gray}` +
          `&color_map=${colorMap}` +
          '&nodata=' +
          this._noData +
          '&minmax=' +
          minmax
        ]
      }
    }
    if (this._cutLine) {
      tile = [
        tile[0] + '&cutline=' + this._cutLine + '&ver=' + utils.getUUID()
      ]
    }
    return tile
  }

  get meta () {
    return this._meta
  }

  get imageType () {
    return this._imageType
  }

  get colorPalette () {
    return this._colorPalette
  }

  set colorPalette (newValue) {
    this._colorPalette = newValue
  }

  get taskId () {
    return this._task_id
  }

  get children () {
    return this._children
  }

  set children (val) {
    this._children = val
  }

  get isOwnerSymbology () {
    return this._isOwnerSymbology
  }

  get listValue () {
    return this._listValue
  }
}



// WEBPACK FOOTER //
// ./src/models/image/image.js